import { useMutation } from "@apollo/client";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useUserContext } from "../../../contexts/UserContext";
import { UserActionTypes } from "../../../contexts/reducers/userReducer";
import { RefreshAccessMutation } from "../../../graphql/deliveryService/mutations/refreshAccess";
import { RefreshAccessFragment } from "../../../models/autogenerated-deliveryService-gql/graphql";
import { handleError } from "../../../utils/graphqlHelper";

interface RefreshAccessMutationProps {
  dataAction?: (data: RefreshAccessFragment) => void;
  errorAction?: () => void;
}

const useRefreshAccessMutation = (props: RefreshAccessMutationProps) => {
  const { t } = useTranslation();
  const { user, dispatchUser } = useUserContext();

  const { dataAction, errorAction } = props;

  const refreshAccessInput = {
    accessToken: user.accessToken || localStorage.getItem("accessToken") || "",
    refreshToken:
      user.refreshToken || localStorage.getItem("refreshToken") || "",
  };

  const mutation = useMutation(RefreshAccessMutation, {
    variables: {
      refreshAccessInput: refreshAccessInput,
    },
  });

  const { data, error } = mutation[1];

  const refreshAccessFragment = data?.refresh.refreshOutput;

  useEffect(() => {
    if (!error) return;

    handleError(t("refreshAccessError"), t(error.message), errorAction);
  }, [error]);

  useEffect(() => {
    if (!data || !refreshAccessFragment) return;

    dispatchUser({
      type: UserActionTypes.RefreshAccess,
      value: refreshAccessFragment,
    });

    dataAction && dataAction(refreshAccessFragment);
  }, [data]);

  return mutation;
};

export default useRefreshAccessMutation;
